import { FormFieldTypes } from "../../../../../../data/formFieldType";
import ProductList from "../components/ProductList";
export const ApplicationInformationData = {
    name: "ApplicationInformation",
    initialState: {
        mainContactPerson: null,
        mainContactPhone: '',
        mainContactEmail: '',
        applicantRole: null,
        criteria: null,
        productDetails: null,
        serviceCategory: null,
        subCategory: null,
        productType: null,
        productCateloueName: "",
        productPictureName: "",
        productsGreenFeatures: "",
        nameOfManufacturingPlant: "",
        addressOfManufacturer: "",
        sameAsManufacturer: false,
        nameOfManufacturingPlant: "",
        addressofManufacturingPlant: "",
        placeofManufacturing: null,
    },
    formFields: [
        {
            id: "mainContactPerson",
            lable: "Main Contact Person",
            Field_Name: "Main Contact Person",
            fieldType: FormFieldTypes.SELECT,
            dataField: "mainContactPerson",

            fieldSetting: {
                placeholder: "Select",
                options: [],
                isDisable: true,
            },
            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },
        {
            id: "mainContactPhone",
            lable: "Main Contact Phone",
            Field_Name: "Main Contact Phone",
            fieldType: FormFieldTypes.INPUT,
            dataField: "mainContactPhone",

            fieldSetting: {
                placeholder: "",
                allowSpace: false,
                isDisable: true,
            },
            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },
        {
            id: "mainContactEmail",
            lable: "Main Contact Email Address",
            Field_Name: "Main Contact Email Address",
            fieldType: FormFieldTypes.INPUT,
            dataField: "mainContactEmail",

            fieldSetting: {
                placeholder: "",
                allowSpace: false,
                isDisable: true,

            },
            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },
        {
            id: "applicantRole",
            lable: "Applicant's Role",
            Field_Name: "Applicant's Role",
            fieldType: FormFieldTypes.SELECT,
            dataField: "applicantRole",

            fieldSetting: {
                placeholder: "Select",
                options: [],
                isDisable: true,
            },
            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },
        {
            id: "criteria",
            lable: "Criteria Selected",
            Field_Name: "Criteria Selected",
            fieldType: FormFieldTypes.SELECT,
            dataField: "criteria",
            fieldSetting: {
                placeholder: "Select",
                options: [],
                isDisable: true,

            },
            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },
        {
            lable: "",
            Field_Name: "Product Details",
            id: "productDetails",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            fieldSetting: {
                formTitle: "Product Details",
                dataField: "productDetails",
                isDisable: true,

            },
            style: {
                containerCss: "custom-grid",
            },
        },
        {
            id: "serviceCategory",
            lable: "Category (L1) ",
            Field_Name: "Category (L1)",
            fieldType: FormFieldTypes.SELECT,
            dataField: "serviceCategory",
            fieldSetting: {
                placeholder: "Select",
                options: [],
                isSearchable: true,
                isDisable: true,

            },
            validation: [{ type: "require" }],
            style: { containerCss: "col-md-4 mb-3" },
        },

        {
            id: "subCategory",
            lable: "Sub Category (L2)",
            Field_Name: "Sub Category (L2)",
            fieldType: FormFieldTypes.SELECT,
            dataField: "subCategory",
            fieldSetting: {
                placeholder: "Select",
                options: [],
                isSearchable: true,
                isDisable: true,

            },
            validation: [{ type: "require" }],
            style: { containerCss: "col-md-4 mb-3" },
        },
        {
            id: "productType",
            lable: "Type (L3)",
            Field_Name: "Type (L3)",
            fieldType: FormFieldTypes.SELECT,
            dataField: "productType",
            fieldSetting: {
                placeholder: "Select",
                options: [],
                isSearchable: true,
                isDisable: true,

            },
            validation: [{ type: "require" }],
            style: { containerCss: "col-md-4 mb-3" },
        },

        {
            id: "searchEmailButton",
            fieldType: FormFieldTypes.COMPONENT,
            additionalComponent: <ProductList />,
            style: {
                containerCss: "col-md-12 mb-3",
            },
        },
        {
            id: "productCateloueName",
            lable: "Product Catalogue (please upload in PDF, JPG, JPEG, PNG. Max 5MB)",
            Field_Name: "Product Catalogue",
            fieldType: FormFieldTypes.FILE,
            dataField: "productCateloueName",
            fieldSetting: {
                // presentFileName: null,
                placeholder: "",
                isDownloadable: false,
                acceptedFiles: ".jpg,.png,.jpeg,.pdf",
                imageCrop: true,
                viewImage: false,
                maxFileSizeInKB: 5000,
                isDisable: true,

            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "productPictureName",
            lable: "Product Picture (please upload in JPG, JPEG, PNG. Max 5MB)",
            Field_Name: "Product Picture",
            fieldType: FormFieldTypes.FILE,
            dataField: "productPictureName",
            fieldSetting: {
                // presentFileName: null,
                placeholder: "",
                isDownloadable: false,
                acceptedFiles: ".jpg, .png, .jpeg",
                imageCrop: true,
                viewImage: true,
                maxFileSizeInKB: 5000,
                isDisable: true,

            },
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },

        {
            id: "productsGreenFeatures",
            lable: "Products Green Features",
            Field_Name: "Products Green Features",
            subLabelName: "(e.g. low VOC level, energy saving properties, recyclability, usage of recycled content, etc.)",
            fieldType: FormFieldTypes.INPUT,
            dataField: "productsGreenFeatures",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: true,

            },
            validation: [{ type: "require" }],
            style: { containerCss: "col-md-12 mb-4 product-feature" },
        },
        {
            id: "serviceDetailsTitle",
            Field_Name: "serviceDetailsTitle",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            fieldSetting: {
                formTitle: "Manufacturer Details",
                isDisable: true,

            },
            style: {
                containerCss: "custom-grid",
            },
        },
        {
            id: "nameOfManufacturingPlant",
            lable: "Name of Manufacturer",
            Field_Name: "Name of Manufacturer",
            fieldType: FormFieldTypes.INPUT,
            dataField: "nameOfManufacturingPlant",

            fieldSetting: {
                placeholder: "Enter Manufacturer Name",
                isDisable: true,

            },

            validation: {
                required: true,
            },

            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },

        {
            id: "addressOfManufacturer",
            lable: "Address of Manufacturer",
            Field_Name: "Address of Manufacturer",
            fieldType: FormFieldTypes.INPUT,
            dataField: "addressOfManufacturer",

            fieldSetting: {
                placeholder: "Enter Manufacturer Address",
                isDisable: true,

            },

            validation: {
                required: true,
            },

            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },

        {
            id: "sameAsManufacturer",
            lable: "Same as Manufacturer",
            Field_Name: "Same as Manufacturer",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "sameAsManufacturer",

            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: true,
            },

            style: {
                containerCss: "col-12 mt-2",
            },
        },

        {
            id: "nameOfManufacturingPlant",
            lable: "Name of Manufacturing Plant",
            Field_Name: "Name of Manufacturing Plant",
            fieldType: FormFieldTypes.INPUT,
            dataField: "nameOfManufacturingPlant",

            fieldSetting: {
                placeholder: "Enter Manufacturing Plant Name",
                isDisable: true,

            },

            validation: {
                required: true,
            },

            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },

        {
            id: "addressofManufacturingPlant",
            lable: "Address of Manufacturing Plant",
            Field_Name: "Address of Manufacturing Plant",
            fieldType: FormFieldTypes.INPUT,
            dataField: "addressofManufacturingPlant",

            fieldSetting: {
                placeholder: "Enter Manufacturing Plant Address",
                isDisable: true,

            },

            validation: {
                required: true,
            },

            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },

        {
            id: "placeofManufacturing",
            lable: "Place of Manufacturing",
            Field_Name: "Place of Manufacturing",
            fieldType: FormFieldTypes.SELECT,
            dataField: "placeofManufacturing",

            fieldSetting: {
                placeholder: "Select Country",
                options: [
                    {
                        label: "Singapore",
                        value: "Singapore",
                    },
                    {
                        label: "India",
                        value: "India",
                    },
                    {
                        label: "Malaysia",
                        value: "Malaysia",
                    },
                ],
                isDisable: true,

            },

            validation: {
                required: true,
            },

            style: {
                containerCss: "col-lg-6 mb-3",
            },
        },
    ],
    formSetting: {
        isViewOnly: false,
    },
};

